// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kccI","largestCol":"styles_largestCol__2uhRF","smallestCol":"styles_smallestCol__32cdz"};